import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    vapidPublicKey: "BFP_4-EuaAppMYFpan5dSoYWIh1Ag3beIyQwXslvBffELE6H81A5ZW29-L6NWjckMr4_at88RqDKgMjdtpyQ6XQ",
    // authCode: null,
    ebayRegions: [
      {
        globalId: "EBAY-AU",
        siteName: "eBay Australia"
      },
      {
        globalId: "EBAY-ENCA",
        siteName: "eBay Canada (English)"
      },
      {
        globalId: "EBAY-GB",
        siteName: "eBay UK"
      },
      {
        globalId: "EBAY-IE",
        siteName: "eBay Ireland"
      },
      {
        globalId: "EBAY-US",
        siteName: "eBay United States"
      }
    ],
    ebayListingTypes: [
      {
        name: "All",
        value: "All"
      },
      {
        name: "Auction",
        value: "Auction"
      },
      {
        name: "Auction with Buy It Now",
        value: "AuctionWithBIN"
      },
      {
        name: "Buy It Now",
        value: "FixedPrice"
      },
      {
        name: "Classified",
        value: "Classified"
      },
      {
        name: "Store Inventory",
        value: "StoreInventory"
      }
    ],
    isAuthorized: false,
    sessionGuid: null,
    sessionToken: null,
    sessionTokenExpiration: null,
    // sessionUser: null,
    userId: null,
    userSearches: [
      /* {id: 63, string: 'willie woodburn'},
      {id: 78, string: '2016 Topps Luis Severino PSA'},
      {id: 83, string: '1984 Mattingly PSA 9'},
      {id: 84, string: 'Topps Mattingly PSA'},
      {id: 88, string: '2017 Topps Chrome Aaron Judge PSA auto'},
      {id: 89, string: '1996 Brian Dawkins PSA'},
      {id: 91, string: '1990 Upper Deck Rod BrindAmour PSA'},
      {id: 92, string: '1979 Topps Wilbert Montgomery PSA'},
      {id: 93, string: '1974 Topps Harold Carmichael PSA'},
      {id: 94, string: '1989 Score Eric Allen PSA'}, */
    ],
    userListings: null
  },
  getters: {
    getSearches (state) {
      return state.userSearches
    },
    getListings (state) {
      return state.userListings
    },
    getSessionGuid (state) {
      return state.sessionGuid
    },
    getSessionToken (state) {
      return state.sessionToken
    },
    getUserId (state) {
      return state.userId
    },
    getVapidPublicKey(state) {
      return state.vapidPublicKey
    }
  },
  mutations: {
    setAuthorized(state, isAuthorized) {
      state.isAuthorized = isAuthorized
    },
    setSessionGuid(state, sessionGuid) {
      // localStorage.setItem("", sessionGuid)
      state.sessionGuid = sessionGuid
    },
    setSessionToken(state, sessionToken) {
      localStorage.setItem("sessionToken", sessionToken)
      state.sessionToken = sessionToken
    },
    setSessionTokenExpiration(state, sessionTokenExpiration) {
      localStorage.setItem("sessionTokenExpiration", sessionTokenExpiration)
      state.sessionTokenExpiration = sessionTokenExpiration
    },
    setUserId(state, userId) {
      localStorage.setItem("sessionUser", userId)
      state.userId = userId
    },
    setUserSearches(state, searches) {
      state.userSearches = searches
    }
  },
  actions: {
    verifyLogin({ commit, state }) {
      // console.log("Verifying login...") // debug
      let userId = state.userId
      // does the user exist?
      let url = `${process.env.VUE_APP_API_ROOT_URL}users/verify/`
      // console.log(url) // debug
      let params = {
        resource: "user",
        action: "verify",
        variables: {
          user_id: userId,
          guild_id: process.env.VUE_APP_GUILD_ID
        }
      }

      Vue.axios.post(url, params)
      .then (function verifyUser (response) {
        let searchCount = response.data.search_count
        if (searchCount > 0) {
          // console.log("Login verified...") // debug
          commit("setAuthorized", true)
        }
      })
      /* .catch (function verifyError (err) {
        // console.log(err)
      }) */
    },
    /* loadSearches ({ commit, state }) {
      let userId = state.userId

      // load searches
      let url = `${process.env.VUE_APP_API_ROOT_URL}searches/list/`
      let params = {
        resource: "search_string",
        action: "list",
        variables: {
          user_id: userId
        }
      }

      Vue.axios.post(url, params)
        .then (function storeSearches (response) {
          let searches = response.data.searches
          // console.log(searches)
          commit("setUserSearches", searches)
        })
        .catch (function searchError (err) {
          // add error handler for when API is down.
          // eslint-disable-next-line
          console.log(err)
        })
      // load listings
    }, */
    generateSessionGuid ({ commit }) {
      let guid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        let r = Math.random() * 16|0, v = c == "x" ? r: (r&0x3|0x8)
        return v.toString(16)
      })
      localStorage.setItem("sessionGuid", guid)
      commit("setSessionGuid", guid)
    },
    logout({ commit }) {
      // Unset user indicative data
      commit("setAuthorized", false)
      commit("setSessionToken", null)
      commit("setUserId", null)
      commit("setSessionTokenExpiration", null)
      // commit("")

      // clear local storage
      localStorage.removeItem("sessionGuid")
      localStorage.removeItem("sessionUser")
      localStorage.removeItem("sessionToken")
      localStorage.removeItem("sessionTokenExpiration")
    },
    addSearch({ commit, state }, search ) {
      // console.log("Add start...") // debug
      let searches = state.userSearches
      searches.push(search)
      commit("setUserSearches", searches)
      // console.log("Add end...") // debug
    },
    deleteSearch({ commit, state }, searchIndex ) {
      // console.log('Delete start...') // debug
      // console.log(`Deleting search index ${searchIndex}`) // debug
      let searches = state.userSearches
      searches.splice(searchIndex, 1)
      commit("setUserSearches", searches)
      // console.log('Delete end...') // debug
    },
    storeSessionData({ commit }, sessionData) {
      commit("setUserId", sessionData.sessionUser)
      commit("setSessionToken", sessionData.access_token)

      let expiresIn = sessionData.expires_in
      let now = new Date()
      let expiration = new Date(now.getTime() + expiresIn * 1000)
      // console.log(expiration)
      commit("setSessionTokenExpiration", expiration)

    }
  },
  modules: {}
});
